import { useState, useRef, useEffect } from "react";
import { FaShoppingCart, FaCog, FaBolt, FaUndo, FaUser, FaCommentDots } from "react-icons/fa";
import avatar from "../../assets/avatar.png";
import logo from "../../assets/logo2.png";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useCart } from "../../context/CartContext";

export default function DashboardNavbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { cart } = useCart();
  const cartItemCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  useEffect(() => {
    const handler = e => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 h-18 bg-white border-b flex items-center justify-between px-4 z-50">
      {/* Left: Logo */}
      <a href="/" className="flex items-center gap-2.5">
        <div className="w-9 h-9 bg-white rounded-full flex items-center justify-center overflow-hidden shadow-sm border border-gray-100 shrink-0">
          <img src={logo} alt="UCH" className="w-7 h-7 object-contain" />
        </div>
        <div className="hidden sm:block">
          <p className="font-bold text-gray-900 text-sm leading-tight">UCH Self Service</p>
          <p className="text-gray-400 text-[10px]">University College Hospital</p>
        </div>
      </a>

      {/* Right: Avatar Dropdown */}
      <div ref={dropdownRef} className="flex items-center">
        <button
          onClick={() => setDropdownOpen(o => !o)}
          className="flex items-center gap-1 px-2 py-1 border border-[#2490ef] rounded-full text-sm"
        >
          <img src={avatar} alt="profile" className="h-5 w-5 rounded-full" />
          <span>{user?.username}</span>-<span>{"₦"}{user?.wallet_balance}</span>
        </button>

        {dropdownOpen && (
          <div className="absolute right-4 top-14 w-48 bg-white border shadow rounded z-50">
            <button
              onClick={() => {
                navigate("/dashboard");
                setDropdownOpen(false);
              }}
              className="flex items-center w-full px-4 py-2 gap-2 text-sm hover:bg-gray-100"
            >
              <FaCog className="text-gray-600" /> Dashboard
            </button>
            
            <button
              onClick={() => { navigate("/withdraw"); setDropdownOpen(false); }}
              className="flex items-center w-full px-4 py-2 gap-2 text-sm hover:bg-gray-100"
            >
              <FaUndo className="text-gray-600" /> Refund
            </button>

            <button
              onClick={() => { navigate("/wallet-pay"); setDropdownOpen(false); }}
              className="flex items-center w-full px-4 py-2 gap-2 text-sm hover:bg-gray-100 relative"
            >
              <FaShoppingCart className="text-gray-600" /> Cart
              {cartItemCount > 0 && (
                <span className="absolute left-8 top-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  {cartItemCount}
                </span>
              )}
            </button>

            <a href="/profile/edit" className="flex items-center px-4 py-2 gap-2 text-sm hover:bg-gray-100">
              <FaUser className="text-gray-600" /> Profile
            </a>

            <button
              onClick={() => { navigate("/feedback"); setDropdownOpen(false); }}
              className="flex items-center w-full px-4 py-2 gap-2 text-sm hover:bg-gray-100"
            >
              <FaCommentDots className="text-gray-600" /> Feedback
            </button>
            
            <button
              onClick={() => {
                logout();
                window.location.href = "/login";
              }}
              className="flex items-center w-full px-4 py-2 gap-2 text-sm hover:bg-gray-100"
            >
              <FaBolt className="text-gray-600" /> Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
}